import Vuex from 'vuex';
import createSyncPlugin from 'src/store/base/sync-module-plugin';

import modules from './modules';
import state from './state';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const noProdENV = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  state,
  mutations: {
    ...mutations,
  },
  modules,
  actions,
  plugins: [
    createSyncPlugin('library/playable-check'), // 用于指定module的内部数据同步插件
    createSyncPlugin('creative/procedural-creative-form'),
    createSyncPlugin('creative/playable-card-form'),
  ],
  strict: noProdENV,
});

export default store;
